
<template>

  <div>

    <el-container>
      <el-header>
        <el-card  style="height:300px;width: 41%;margin:0 auto;">
          <el-descriptions class="margin-top" title="登录信息" :column="3"  border>
            <template slot="extra">
              <el-button type="primary" v-on:click="GetPlan"  size="small">批量搭建</el-button>
              <el-button type="primary" v-on:click="GetRo"  size="small">刷新</el-button>
              <el-button type="primary" v-on:click="findIds"  size="small">查询</el-button>
              <el-button type="primary" v-on:click="ro"  size="small">重置标题</el-button>
              <el-button type="primary" v-on:click="clearFiles1"  size="small">重置素材</el-button>

            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                姓名
              </template>
              <div class="block">
                <!--              <el-cascader-->
                <!--                v-model="names"-->
                <!--                :options="name"-->
                <!--                filterable></el-cascader>-->
                <el-select v-model="username" filterable placeholder="请选择">
                  <el-option
                    v-for="(items,i) in listname"
                    :key="i"
                    :value="items.username">
                  </el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                登录二代
              </template>
              微驰
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                账户列表
              </template>

              <el-select v-model="towName" filterable placeholder="请选择">
                <el-option
                  v-for="(items,i) in two"
                  :key="i"
                  :value="items.twoname">
                </el-option>
              </el-select>

            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                广告主账户列表
              </template>
              <!--            <el-select v-model="idsname" placeholder="请选择">-->
              <!--              <el-option-->
              <!--                v-for="(items,i) in idsList"-->
              <!--                :key="i"-->
              <!--                :value="items.idsname">-->
              <!--              </el-option>-->
              <!--            </el-select>-->
              <el-tag :key="i" v-for="(item,i) in idsList">{{item.idsname}}</el-tag>

            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-header>
      <el-container>
        <el-aside width="1000px" >
          <div style="height:500px;position: absolute;left:200px;top: 320px">
            <el-steps direction="vertical" :active="1">
              <el-step process-status="success" title="创建计划"></el-step>
              <el-step title="创建广告组"></el-step>
              <el-step process-status="success"	 title="创建广告" description="需要上传图片素材"></el-step>
            </el-steps>
          </div>




        </el-aside>
        <el-container>
          <el-main style="height: 800px;width:1000px">
            <!--          搭建计划代码-->
            <el-card class="box-card1" style="height:30%;">

              <div slot="header" class="clearfix">
                <el-form label-position="right"  :model="formLabelAlign">
                  <el-form-item  label="计划名称:">
                    <el-input style="width: 200px" v-model="formLabelAlign.name"></el-input>
                  </el-form-item>



                  <el-form-item label="投放渠道:">
                    <el-select v-model="formLabelAlign.mediaType" placeholder="请选择">
                      <el-option
                        v-for="item1 in option1"
                        :key="item1.value"
                        :label="item1.label"
                        :value="item1.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="计划开关:">
                    <el-switch
                      v-model="flag"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>

                </el-form>
              </div>

            </el-card>
            <el-card class="box-card2" style="height:40%;">

              <div slot="header" style="margin-left: 0px" class="clearfix">

                <el-form label-position="right" :model="formLabelAlign1">
<!--                  <el-form-item label="计划限额:">-->
<!--                    <el-select v-model="formLabelAlign1.cvType" placeholder="请选择">-->
<!--                      <el-option-->
<!--                        v-for="item1 in options3"-->
<!--                        :key="item1.value"-->
<!--                        :label="item1.label"-->
<!--                        :value="item1.value">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
<!--                  </el-form-item>-->
                  <el-form-item label="二阶出价:" style="margin-top: 20px">
                    <el-input style="width: 100px;"  v-model="formLabelAlign1.ocpxPrice"></el-input>元
                  </el-form-item>
                  <el-form-item label="投放时间段:">
                    <el-select v-model="time_list" placeholder="请选择">
                      <el-option
                        v-for="item1 in timeList"
                        :key="item1.value"
                        :label="item1.label"
                        :value="item1.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </el-form>
              </div>

            </el-card>
            <el-card class="box-card3" style="height:70%;">

              <div slot="header" class="clearfix">
                <el-form label-position="right"  :model="formLabelAlign3">
                  <el-form-item  label="展现形式:">
                    <!--                  <el-select v-model="formLabelAlign3.placeType" placeholder="请选择">-->
                    <!--                    <el-option-->
                    <!--                      v-for="item1 in options4"-->
                    <!--                      :key="item1.value"-->
                    <!--                      :label="item1.label"-->
                    <!--                      :value="item1.value">-->
                    <!--                    </el-option>-->
                    <!--                  </el-select>-->
                    <el-cascader
                      v-model="formLabelAlign3.placeType"
                      :options="options4"
                      filterable></el-cascader>
                  </el-form-item>
                  <el-form-item label="标题打乱(默认关闭):">
                    <el-switch
                      v-model="daluan"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="*产品名:" style="margin-top: 20px">
                    <el-input style="width: 200px;"  v-model="formLabelAlign3.productName"></el-input>
                  </el-form-item>
                  <el-form-item label="标题1：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[0]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题2：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[1]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题3：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[2]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题4：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[3]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题5：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[4]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题6：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[5]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题7：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[6]"></el-input>
                  </el-form-item>
                  <el-form-item label="标题8：" style="margin-top: 20px">
                    <el-input style="width: 440px;"  v-model="formLabelAlign3.title[7]"></el-input>
                  </el-form-item>



                </el-form>
              </div>

            </el-card>
            <!--          图片素材代码-->
            <el-card class="box-cards" style="height:15%;">
              <div slot="header" class="clearfix">
                <span >批量搭建任务进度</span>
              </div>
              <el-row>
                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentages"></el-progress>
              </el-row>
              <!--          <el-dialog :visible.sync="dialogVisible">-->
              <!--            <img width="20%" :src="dialogImageUrl" alt="">-->
              <!--          </el-dialog>-->
            </el-card>
            <el-tabs class="box-card" v-model="updateType" >
              <el-tab-pane label="图片素材" name="first">
                <el-card class="box-card" style="height:90%;">
                <div slot="header" class="clearfix">
                  <span >素材上传工作区</span>
                </div>
                <el-row>
                  <el-upload
                    ref='upload'
                    :multiple="true"
                    action="#"
                    scoped-slot="text"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :auto-upload="false"
                    :limit="9"
                    :file-list="fileList"
                    :on-change='onChange'
                    :on-remove="handleRemove">
                    <i class="el-icon-plus test"></i>
                  </el-upload>
                  <el-tag>素材上传进度</el-tag>
                  <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentage"></el-progress>

                </el-row>
                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>
              </el-card>
              </el-tab-pane>
              <el-tab-pane label="视频素材" name="second">
                <el-card class="box-card" style="height:90%;">
                  <div slot="header" class="clearfix">
                    <span >视频素材上传工作区</span>
                  </div>
                  <el-row>
                    <el-upload
                      ref='upload12'
                      :multiple="true"
                      action="#"
                      scoped-slot="text"
                      :on-preview="handlePictureCardPreview2"
                      :auto-upload="false"
                      :limit="9"
                      :on-change='onChange2'
                      :file-list="VideofileList"
                      :on-remove="handleRemove2">
                      <i class="el-icon-plus test"></i>
                    </el-upload>
                    <el-tag>素材上传进度</el-tag>
                    <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentage"></el-progress>
                              <el-dialog :visible.sync="dialogVisible">
                                <img width="20%" :src="dialogImageUrl" alt="">
                              </el-dialog>
                  </el-row>
                  <el-button type="primary"  @click="clearfile" size="small">一键清除</el-button>
                </el-card>
              </el-tab-pane>

            </el-tabs>

          </el-main>

        </el-container>
      </el-container>
    </el-container>






  </div>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      daluan:false,
      flag:false,
      updateType:'',
      listname:[],
      time_list:'',
      timeList:[{
        value:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
        label:'全天投放'
      },
        {
          value:'000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
          label:'五点'
        },
        {
          value:'000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
          label:'六点'
        },
        {
          value:'000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
          label:'七点'
        },
        {
          value:'000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
          label:'八点半'
        },
        {
          value:'000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
          label:'九点后'
        },
        {
          value:'000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
          label:'九点半'
        },
        {
          value:'000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
          label:'十点'
        },
        {
          value:'000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
          label:'十点半'
        },
        {
          value:'000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
          label:'十一点'
        },{
          value:'000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
          label:'十四点'
        },
        {
          value:'000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
          label:'十六点'
        },
        {
          value:'000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
          label:'十七点'
        },
        {
          value:'000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
          label:'十八点'
        }],
      names:'',
      idsname:[],
      option1: [{
        value: '1',
        label: '非应用商店'
      },
        {
          value: '2',
          label: '广告联盟'
        }],


      options3: [{
        value: '4',
        label: '表单提交'
      }, {
        value: '7',
        label: '添加到桌面'
      },{
        value: '12',
        label: '自定义付费'
      }],
      options4: [{
        value: '1',
        label: '信息流',
        children: [{
          value: '62',
          label: '横板大图',
        },
          {
            value: '4',
            label: '组图',
          },
          {
            value: '3',
            label: '小图',
          },{
          value: '61',
            label: '横板视频'
          }]
      },
        //   {
        //   value: '2',
        //   label: '开屏'
        // },{
        //   value: '3',
        //   label: 'banner'
        // },
        {
          value: '5',
          label: '原生广告',
          children: [{
            value: '48',
            label: '横板大图',
          },
            {
              value: '209',
              label: '竖版大图',
            },
            {
              value: '4',
              label: '组图',
            },
            {
              value: '121',
              label: '小图',
            },
            // {
            //   value: '122',
            //   label: '横板视频'
            // },
            // ,{
            //   value: '242',
            //   label: '竖版视频'
            // }
            ],

        },      {
          value:'9',
          label: '激励视频',
          children: [
            {
              value: '60',
              label: '横板视频'
            }
            ,{
              value: '131',
              label: '竖版视频'
            },]
        }
        //   {
        //   value: '4',
        //   label: '插屏'
        // }
      ],
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: ''
      },
      normId:[61,4,3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productName:'',
      },
      percentage:0,
      percentages:0,
      fileList: [],
      VideofileList: [],

      creativeList:[],
      arr:{},
      idsList:[
        {
          id:'',
          username:'',
          ids:'',
          twoname:'',
          url:'',
          xiaoshuourl:'',
          token:'',
          idsname:'',
          planId:'',
          groundId:'',
          planName:''
        }
      ],
      androidVersionSet:[1650006,1650007,1650008,1650001,1650002,1650009,1650010,1650011],
      regionCodeList: [
        // 120000,
        130000,
        140000,
        150000,
        210000,
        220000,
        230000,
        // 310000,
        320300,320500,320600,320700,320900,321000,321200,321300,
        // 330000,
        330200,330300,330400,330500,330600,330700,330800,330900,331000,331100,
        340000,
        // 350000,
        350200,350300,350400,350500,350600,350700,350900,
        360000,
        370000,
        410000,
        // 420000,
        420200,420300,420500,420600,420700,420800,420900,421000,421100,421200,421300,422800,429078,429093,429094,429095,
        430000,
        // 440100,
        440200,
        440400,
        440500,
        // 440600,
        440700,
        440800,
        440900,
        441200,
        441300,
        441400,
        441500,
        441600,
        441700,
        441800,
        // 441999,
        442099,
        445100,
        445200,
        445300,
        450000,
        // 460000,
        460100,460399,469069,460499,469070,469071,469072,469073,469074,469075,469076,469077,469078,469092,469093,469094,469097,469098,
        500000,
        // 510000,
        510100,510300,510400,510500,510600,510700,510800,510900,511000,511100,511300,511400,511500,511600,511700,511800,511900,512000,513200,513300,513400,
        // 520000,
        520100,520200,520300,520400,520500,522300,522600,522700,
        530000,
        540000,
        // 610000,
        610200,610300,610400,610500,610600,610700,610800,610900,611000,
        620000,
        630000,
        640000,
        650000,
        // 710199,
        // 810000,
        // 820000,


      ],
      dialogImageUrl: '',
      dialogVisible: false,
      fileCode:[],
      videofileCode:[],
      two:[{
        id:'',
        twoname:'',
      }],
      // towToken:[],
      towName:'',
      username:'',
    };
  },
  methods: {
    shuffle(arr){
  var l = arr.length
  var index, temp
  while(l>0){
    index = Math.floor(Math.random()*l)
    temp = arr[l-1]
    arr[l-1] = arr[index]
    arr[index] = temp
    l--
  }
  return arr
},
    clearfile(){
      let arr1 =[this.fileList[0]];
      this.fileList = arr1
      this.VideofileList=[]
    },
    async GetPlan(){
      console.log(this.formLabelAlign3.placeType[1])
     if (this.formLabelAlign3.placeType[1]==='61'){
        let t=0;

        for (let key in this.idsList){

          if (this.daluan===true){
            this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
          }
          this.fileCode=[],
            this.videofileCode=[]
          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          let parms1={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          await this.upload(parms)
          await this.uploadVideo(parms1)
          await this.plan(parms)
          let groundData={
            token:this.idsList[key].token,
            ids:this.idsList[key].ids,
            campaignId:this.idsList[key].planId,
            webSiteUrl:this.idsList[key].url,
            id:key,
            startDate:this.startDate,
            ocpxPrice:this.formLabelAlign1.ocpxPrice*100000,
            name:this.idsList[key].planName,
            cvType: this.formLabelAlign1.cvType,
            builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
          }
          await this.stopPlan(groundData)
          await this.ground(groundData)
          let data ={
            token:this.idsList[key].token,
            ids:this.idsList[key].ids,
            groupId:this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          this.creativeList=[];
          let t=0;
          for (let code=1;code<this.fileCode.length;code++){
            t=t+1;

            this.arr={}
            this.arr.avatarCode=this.fileCode[0];
            this.arr.imgsCode=this.fileCode[code];
            this.arr.videoCode=this.videofileCode[code-1];
            this.arr.title=this.formLabelAlign3.title[code-1];
            this.arr.placeType=this.formLabelAlign3.placeType[0];
            this.arr.productName=this.formLabelAlign3.productName;
            this.arr.subTitle=this.formLabelAlign3.title[code-1];

            this.arr.appName=this.formLabelAlign3.productName;
            // this.arr.virtualPositionId=12;
            // this.arr.materialNormId=48;
            if (this.formLabelAlign.mediaType==='1'){
              // this.arr.virtualPositionId=13;
              this.arr.virtualPositionId="1,2,13,17"
            }else {
              this.arr.virtualPositionId=12;
            }
            this.arr.materialNormId=this.formLabelAlign3.placeType[1];

            this.creativeList[code-1]=this.arr;
            console.log(this.fileCode[code])
            console.log('视频code'+this.videofileCode[code])
            console.log(this.arr)
          }
          if (t===this.fileCode.length-1){
            let t1={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              creativeList:this.creativeList,
              groupId:this.idsList[key].groundId,
              name:this.idsList[key].planName,
              clickMonitorUrl:this.idsList[key].xiaoshuourl
            }
            await this.guanggao(t1)
          }
          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
          console.log(this.percentages)
        }
        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }
      }
     else if(this.formLabelAlign3.placeType[1]=='4'){

       let t=0;
       for (let key in this.idsList){
         if (this.daluan===true){
           this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
         }
         this.fileCode=[]
         let parms={
           name:this.idsList[key].planName,
           mediaType:this.formLabelAlign.mediaType,
           id:key,
           token:this.idsList[key].token,
           ids:this.idsList[key].ids
         }
         await this.upload(parms)
         await this.plan(parms)
         let groundData={
           token:this.idsList[key].token,
           ids:this.idsList[key].ids,
           campaignId:this.idsList[key].planId,
           webSiteUrl:this.idsList[key].url,
           id:key,
           startDate:this.startDate,
           ocpxPrice:this.formLabelAlign1.ocpxPrice*100000,
           name:this.idsList[key].planName,
           cvType: this.formLabelAlign1.cvType,
           builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
         }
         await this.stopPlan(groundData)
         await this.ground(groundData)
         let data ={
           token:this.idsList[key].token,
           ids:this.idsList[key].ids,
           groupId:this.idsList[key].groundId,
         }
         await this.PostGroupTime(data)
         this.creativeList=[];
         let t=0;
         for (let code=0;code<this.fileCode.length;code+=3){
           t=t+1;
           this.arr={}
           console.log("test"+code)
           const codeStr = `${this.fileCode[code]},${this.fileCode[code+1]},${this.fileCode[code+2]}`;
           this.arr.imgsCode=codeStr;

           this.arr.title=this.formLabelAlign3.title[t-1];
           this.arr.placeType=this.formLabelAlign3.placeType[0];
           this.arr.productName=this.formLabelAlign3.productName;
           this.arr.subTitle=this.formLabelAlign3.title[t-1];

           this.arr.appName=this.formLabelAlign3.productName;
           // this.arr.virtualPositionId=12;
           // this.arr.materialNormId=48;
           if (this.formLabelAlign.mediaType==='1'){
             // this.arr.virtualPositionId=13;
             this.arr.virtualPositionId="1,2,13"
           }else {
             this.arr.virtualPositionId=12;
           }
           this.arr.materialNormId=this.formLabelAlign3.placeType[1];

           this.creativeList[t-1]=this.arr;
           console.log(this.fileCode[code])
           console.log(this.arr)
         }

           let t1={
             token:this.idsList[key].token,
             ids:this.idsList[key].ids,
             creativeList:this.creativeList,
             groupId:this.idsList[key].groundId,
             name:this.idsList[key].planName,
             clickMonitorUrl:this.idsList[key].xiaoshuourl
           }

           await this.guanggao(t1)

         let num=100/this.idsList.length;
         this.percentages=num*(Number(key)+1);
         console.log(this.percentages)





       }
       if (this.percentages===100){
         this.$notify({
           title: 'success',
           message: '批量搭建工程全部完成！',
           type: 'success'
         });
       }


     }
    else if (this.formLabelAlign3.placeType[1]==='60' || this.formLabelAlign3.placeType[1]==='131'){
        console.log("video")
        let t=0;

        for (let key in this.idsList){
          if (this.daluan===true){
            this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
          }
          this.fileCode=[],
            this.videofileCode=[]
          let parms={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          let parms1={
            name:this.idsList[key].planName,
            mediaType:this.formLabelAlign.mediaType,
            id:key,
            token:this.idsList[key].token,
            ids:this.idsList[key].ids
          }
          await this.upload(parms)
          await this.uploadVideo(parms1)
          await this.plan(parms)
          let groundData={
            token:this.idsList[key].token,
            ids:this.idsList[key].ids,
            campaignId:this.idsList[key].planId,
            webSiteUrl:this.idsList[key].url,
            id:key,
            startDate:this.startDate,
            ocpxPrice:this.formLabelAlign1.ocpxPrice*100000,
            name:this.idsList[key].planName,
            cvType: this.formLabelAlign1.cvType,
            builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink

          }
          await this.stopPlan(groundData)
          await this.ground(groundData)
          let data ={
            token:this.idsList[key].token,
            ids:this.idsList[key].ids,
            groupId:this.idsList[key].groundId,
          }
          await this.PostGroupTime(data)
          this.creativeList=[];
          let t=0;
          for (let code=1;code<this.fileCode.length;code++){
            t=t+1;

            this.arr={}
            if (this.idsList[key].url.substr(0, 2)==="ht") {
              this.arr.avatarCode=this.fileCode[0];
            }
            this.arr.imgsCode=this.fileCode[code];
            this.arr.videoCode=this.videofileCode[code-1];
            this.arr.title=this.formLabelAlign3.title[code-1];
            this.arr.placeType=this.formLabelAlign3.placeType[0];
            this.arr.productName=this.formLabelAlign3.productName;
            this.arr.subTitle=this.formLabelAlign3.title[code-1];

            this.arr.appName=this.formLabelAlign3.productName;
            // this.arr.virtualPositionId=12;
            // this.arr.materialNormId=48;
            if (this.formLabelAlign.mediaType==='1'){
              // this.arr.virtualPositionId=13;
              this.arr.virtualPositionId="1,2,13,17"
            }else {
              this.arr.virtualPositionId=15;
            }
            this.arr.materialNormId=this.formLabelAlign3.placeType[1];

            this.creativeList[code-1]=this.arr;
            console.log(this.fileCode[code])
            console.log('视频code'+this.videofileCode[code])
            console.log(this.arr)
          }

          if (t===this.fileCode.length-1){
            let t1={
              token:this.idsList[key].token,
              ids:this.idsList[key].ids,
              creativeList:this.creativeList,
              groupId:this.idsList[key].groundId,
              name:this.idsList[key].planName,
              clickMonitorUrl:this.idsList[key].xiaoshuourl
            }
            await this.guanggao(t1)
          }
          let num=100/this.idsList.length;
          this.percentages=num*(Number(key)+1);
          console.log(this.percentages)



        }
        if (this.percentages===100){
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
        }

      }

     else if(this.formLabelAlign3.placeType[1]!=='61'){

  let t=0;
  for (let key in this.idsList){
      if (this.daluan===true){
        this.formLabelAlign3.title=this.shuffle(this.formLabelAlign3.title)
      }
      this.fileCode=[]
      let parms={
        name:this.idsList[key].planName,
        mediaType:this.formLabelAlign.mediaType,
        id:key,
        token:this.idsList[key].token,
        ids:this.idsList[key].ids
      }
      await this.upload(parms)
      await this.plan(parms)
      let groundData={
        token:this.idsList[key].token,
        ids:this.idsList[key].ids,
        campaignId:this.idsList[key].planId,
        webSiteUrl:this.idsList[key].url,
        id:key,
        startDate:this.startDate,
        ocpxPrice:this.formLabelAlign1.ocpxPrice*100000,
        name:this.idsList[key].planName,
        cvType: this.formLabelAlign1.cvType,
        builtInRpkDeepLink:this.idsList[key].builtInRpkDeepLink
      }
      await this.stopPlan(groundData)
      await this.ground(groundData)
      let data ={
        token:this.idsList[key].token,
        ids:this.idsList[key].ids,
        groupId:this.idsList[key].groundId,
      }
      await this.PostGroupTime(data)
      this.creativeList=[];
      let t=0;
      for (let code=1;code<this.fileCode.length;code++){
        t=t+1;

        this.arr={}
        this.arr.avatarCode=this.fileCode[0];
        this.arr.imgsCode=this.fileCode[code];
        this.arr.title=this.formLabelAlign3.title[code-1];
        this.arr.placeType=this.formLabelAlign3.placeType[0];
        this.arr.productName=this.formLabelAlign3.productName;
        this.arr.subTitle=this.formLabelAlign3.title[code-1];

        this.arr.appName=this.formLabelAlign3.productName;
        // this.arr.virtualPositionId=12;
        // this.arr.materialNormId=48;
        if (this.formLabelAlign.mediaType==='1'){
          // this.arr.virtualPositionId=13;
          this.arr.virtualPositionId="1,2,13"
        }else {
          this.arr.virtualPositionId=12;
        }
        this.arr.materialNormId=this.formLabelAlign3.placeType[1];

        this.creativeList[code-1]=this.arr;
        console.log(this.fileCode[code])
        console.log(this.arr)
      }

      if (t===this.fileCode.length-1){
        let t1={
          token:this.idsList[key].token,
          ids:this.idsList[key].ids,
          creativeList:this.creativeList,
          groupId:this.idsList[key].groundId,
          name:this.idsList[key].planName,
          clickMonitorUrl:this.idsList[key].xiaoshuourl
        }

        await this.guanggao(t1)
      }
      let num=100/this.idsList.length;
      this.percentages=num*(Number(key)+1);
      console.log(this.percentages)





  }
  if (this.percentages===100){
    this.$notify({
      title: 'success',
      message: '批量搭建工程全部完成！',
      type: 'success'
    });
  }


}
    },
    ro(){
      this.formLabelAlign3.title=[]

    },
    async findIds(){

      this.idsList=[],
        await axios.post('https://test.nbweiou.cn/api/get_ids',{
          'username':this.username,
          'twoname':this.towName
        }).then(
          async res=>{
            this.idsList=res.data;
          },
        )
    },

    //刷新信息
    async GetRo(){


      let time1 = parseInt(new Date().getTime()) + '';

      console.log(this.formLabelAlign3.title)
      console.log(time1)

      await axios.post('https://test.nbweiou.cn/api/get_vivo_user',{
        'username':this.username
      }).then(
        res=>{
          this.two=res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )
    },
    //停止计划api
    async stopPlan(parms){
      let flag1=0;
      if (this.flag===false){
        flag1=1
      }else {
        flag1=0;
      }
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',
        {
          "ids": parms.campaignId,
          "startAndStop": flag1
        }).then(res=>{

        //推广计划id id
      })
    },
    // 搭建计划api
    async plan(parms){
      let adtypes=1;
      let names='';
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      if (this.idsList[parms.id].url.substr(0, 2)==="ht") {
        adtypes=1
         names=parms.name+'_'+time1+'_'+'https_'+this.formLabelAlign.name;

      }else if (this.idsList[parms.id].url.substr(0, 2)==="ha"){
        adtypes=8
         names=parms.name+'_'+time1+'_'+'hap_'+this.formLabelAlign.name;

      }


      await axios.post('api/openapi/v1/ad/campaign/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',
        {
          name:names,
          adType:adtypes,
          mediaType:parms.mediaType,
          dailyBudget:-1,
          optimizeFlag:0,
          campaignType:0,
        }).then(res=>{
        if (res.data.code===70111){
          this.$notify({
            title: '创建失败',
            message: res.data.message,
            type: 'error'
          });
        }
        this.idsList[parms.id].planId=res.data.data.id
        console.log(res.data);
        //推广计划id id
      })

    },
    // 搭建广告组api
    async ground(parms){
      let map = {};
      let region={
        'regionCodeList':this.regionCodeList,
        'stayType':1
      }
      let cvType=0;
      let price=0;
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      map["region"]=region;
      map["androidVersionSet"]=this.androidVersionSet;
      // let price1=30000;
      if (this.formLabelAlign.mediaType==='1'){
        price=220000
      }else {
        price=10000
      }
      if (this.idsList[parms.id].url.substr(0, 2)==="ht") {
        cvType=7
        await axios.post('api/openapi/v1/ad/group/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids,
          {
            audienceInfo:map,
            industry1:2100023,
            industry2:2220187,
            campaignId:parms.campaignId,
            webSiteUrl:parms.webSiteUrl,
            h5Type:2,
            startDate:this.getNowFormatDate(),
            endDate:'2038-01-19',
            scheduleTime:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
            chargeType:3,
            price:price,
            cvType:cvType,
            ocpxPrice:parms.ocpxPrice,
            name:parms.name+'_'+time1+'_'+'https_'+this.formLabelAlign.name,

            builtInRpkDeepLink:parms.builtInRpkDeepLink,
            dailyBudget:-1,
            spentType:1,
            //channelId:parms.channelId,
            biddingStrategy:0
          }).then(res=>{
          if (res.data.code===70111){
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }
          console.log(res);
          this.idsList[parms.id].groundId=res.data.data
          //广告组ID

        })
      }else {
        cvType=5
        await axios.post('api/openapi/v1/ad/group/add?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids,
          {
            audienceInfo:map,
            industry1:2100023,
            industry2:2220187,
            campaignId:parms.campaignId,
            rpkDeepLink:parms.webSiteUrl,
            h5Type:2,
            startDate:this.getNowFormatDate(),
            endDate:'2038-01-19',
            scheduleTime:'111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
            chargeType:3,
            price:price,
            cvType:cvType,
            ocpxPrice:parms.ocpxPrice,
            name:parms.name+'_'+time1+'_'+'hap_'+this.formLabelAlign.name,
            dailyBudget:-1,
            spentType:1,
            //channelId:parms.channelId,
            biddingStrategy:0
          }).then(res=>{
          if (res.data.code===70111){
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
          }
          console.log(res);
          this.idsList[parms.id].groundId=res.data.data
          //广告组ID

        })
      }

    },
    // 创建广告api
    async guanggao(parms){
      console.log('-----------------------')
      // console.log(parms.creativeList)
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/advertisement/add/customize/adCreative?access_token='+parms.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+parms.ids+'',
        {
          creativeList:parms.creativeList,
          groupId:parms.groupId,
          name:parms.name+'_'+time1+'_'+this.formLabelAlign.name,
          clickMonitorUrl:parms.clickMonitorUrl
        }).then(res=>{
        if (res.data.code===70111){
          this.$notify({
            title: '创建失败',
            message: res.data.message,
            type: 'error'
          });
        }
        console.log(res.data);
        //广告组ID

      })
    },
    //获取时间方法
    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    //图片上传api
    async upload(ps){
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      console.log(this.fileList)
      let num=100/this.fileList.length;

      for (let i=0;i<this.fileList.length;i++){
        let nonce = Math.round(Math.random() * 100000000000)
        let formData=new FormData()

        formData.append('file',this.fileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/image?access_token='+ps.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+ps.ids+'',
          formData).then(res=>{
          console.log(res);
          console.log(res.data.data.fileCode);
          this.fileCode[i]=res.data.data.fileCode;
          this.percentage=num*(i+1);
          // // console.log(res.data.data.fileCode);
          // // console.log(res.data.data.fileFullPath);
        })
      }
      if (this.percentage===100){
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.fileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },
    // 视频上传api
    async uploadVideo(ps){
      let time1 = parseInt(new Date().getTime()) + '';
      // 上传图像通常要将文件参数放在fromdata 对象中
      // 创建formData实例
      // 向formData实例中追加属性 (参数1：属性名 参数2：属性值)
      console.log(this.VideofileList)
      let num=100/this.VideofileList.length;

      for (let i=0;i<this.VideofileList.length;i++){
        let nonce = Math.round(Math.random() * 100000000000)
        let formData=new FormData()

        formData.append('file',this.VideofileList[i].raw)
        await axios.post('api/openapi/v1/upload/file/video?access_token='+ps.token+'&timestamp='+time1+'&nonce='+nonce+'&advertiser_id='+ps.ids+'',
          formData).then(res=>{
          console.log(res.data.data.fileCode);
          this.videofileCode[i]=res.data.data.fileCode;
          this.percentage=num*(i+1);
          console.log('视频code'+this.videofileCode)
          // console.log(res.data.data.fileCode);
          // console.log(res.data.data.fileFullPath);
        })
      }
      if (this.percentage===100){
        this.$notify({
          title: 'success',
          message: '素材上传成功',
          type: 'success'
        });
      }

      console.log(this.videofileCode);//这里输出的是一个空的formData对象，因为formData是加密处理的我们看不到其内容，但的的确确添加进去了。

    },
    //修改日期Api
    async PostGroupTime(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.ids,
        {
          "ids":pams.groupId,
          "scheduleTime":this.time_list,
        }).then(resp=>{
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog=false
        }

      })


    },
    change(){
      console.log(this.towName)
    },
    onChange(a, fileList) {
      console.log(this.fileList)
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onChange2(a, fileList) {
      console.log(this.fileList)
      this.VideofileList = fileList;
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview2(file) {


    },
    clearFiles1(file,fileList){
      this.$refs.upload.clearFiles()
      this.$refs.upload12.clearFiles()

    },

  },
  created(){
    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/find_list_name',{
    }).then(
      res=>{
        this.listname=res.data
        console.log(this.listname)
      }
    )
  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
  top: 350px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 40%;
}
.box-card2 {
  position: absolute;
  top: 550px;
  bottom: 0;
  left: 0;
  right: 0;
  margin:0 auto;
  width: 40%;
}
.box-card3 {
  position: absolute;
  top: 750px;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin:0 auto;
  width: 40%;
}
.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; bottom: 35px;right: 30px;
  width: 25%;
}
.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed; top: 20px;left: 30px;
  width: 20%;
}
.jdt{
  margin:0 auto;
}
.el-icon-plus{
  width: 20px;
  height: 20px;
}
.test{
  width: 20px;
  height: 20px;
}

</style>


















// WEBPACK FOOTER //
// src/components/login/jus.vue